import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter as Router,Switch,Route} from "react-router-dom";


import Home from './components/pages/Home/Home';
import Surf from './components/pages/Surf/Surf';
import Search from './components/pages/Search/Search';
import Tags from './components/pages/Tags/Tags';
import Relative from './components/pages/Relative/Relative';
import Library_BooksAbbSigns from './components/pages/Library/Library_BooksAbbSigns';
import Library_RelatedArticles from './components/pages/Library/Library_RelatedArticles';
import Library_Resources from './components/pages/Library/Library_Resources';

import Help_Search from './components/pages/Help/Help_Search';
import Help_Tags from './components/pages/Help/Help_Tags';
import AboutUs from './components/pages/AboutUs/AboutUs';
import Support from './components/pages/Support/Support';
import ContactUs from './components/pages/ContactUs/ContactUs';
import Book from './components/pages/Book/Book';
import Books from './components/pages/Book/Books';
//import Glossary from './components/pages/Glossary/Glossary';

class App extends React.Component{
  // componentDidMount(){
  //   document.title = "Parsig Database"
  // }
  render(){
    return (
      <Router basename="">
        <Switch>
          {//<Route path={"/search/:SelectedBook/:SelectedChapter/:SearchTabIndex/:word"} component={Search}/>
          }
          <Route path={"/search"} component={Search}/>
          <Route path={"/surf"} component={Surf}/>
          <Route path={"/tags"} component={Tags}/>
          <Route path={"/relative"} component={Relative}/>
          <Route path={"/library_signs"} component={Library_BooksAbbSigns}/>
          <Route path={"/library_art"} component={Library_RelatedArticles}/>
          <Route path={"/library_res"} component={Library_Resources}/>
          <Route path={"/help_search"} component={Help_Search}/>
          <Route path={"/help_tags"} component={Help_Tags}/>
          <Route path={"/aboutus"} component={AboutUs}/>
          <Route path={"/support"} component={Support}/>
          <Route path={"/contactus"} component={ContactUs}/>
          <Route path={"/book/:bookcode"} component={Book}/>
          <Route path={"/books/:bookgroupcode"} component={Books}/>
          <Route path={"/books"} component={Books}/>
          {//<Route path={"/glossary"} component={Glossary}/>
          }
          <Route path={"/:lang"} component={Home}/>
          <Route path={"/"} component={Home}/>
        </Switch>
      </Router>
   );
  }
}

ReactDOM.render(<App />,window.document.getElementById('root'));